export default {plugin:{third_party_connector:{ui:{connect:'Connect with {{ auth_name }}',remove:'Remove {{ auth_name }}'}}}};